import { createRoute } from "../../../utils";

import {
  courseChapterProjectsRoutesObj,
  courseChapterProjectsBreadcrumbs,
} from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";

const permission = [IRole.FACULTY_MEMBER];

const courseChapterProjectsRouteMetadata: IRouteMetadataObj<
  typeof courseChapterProjectsRoutesObj
> = {
  create: {
    title: "addNewProject",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterProject/page"
      ),
    mode: "create",
    permission,
  },
  edit: {
    title: "editProjectOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterProject/page"
      ),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewProjectOf",
    lazy: () =>
      import(
        "@/pages/facultyMemberPanel/courseManagement/courseChapterProject/page"
      ),
    mode: "view",
    permission,
  },
};

export const courseChapterProjectsRoutes = createRoute<
  typeof courseChapterProjectsRoutesObj
>(
  courseChapterProjectsRoutesObj,
  courseChapterProjectsRouteMetadata,
  courseChapterProjectsBreadcrumbs,
);
